<template>
  <v-menu
    open-on-hover
    bottom
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        dark
        v-bind="attrs"
        v-on="on"
        text
      >
        <span class="mr-2">{{ locale }}</span>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-for="item of items" v-bind:key="item.locale">
        <v-list-item-title>
          <v-btn
            style="width: 100%"
            text
            @click="changeLanguage(item.locale)">
            <span class="mr-2">{{ item.title }}</span>
          </v-btn>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { defineComponent } from 'vue';
import locales from '@/i18n/locales';
import { useI18n } from 'vue-i18n-composable';

export default defineComponent({
  setup() {
    const { locale } = useI18n();

    const changeLanguage = (value) => {
      locale.value = value;
    }

    return {
      // state
      items: locales,
      locale,
      // methods
      changeLanguage,
    }
  },
});
</script>